//
// CompactFormatOptions.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../BaseUIModel";
import "./CompactFormatScale";
import "./CompactFormatPrecision";

var CompactFormatOptions = createModule("commons::CompactFormatOptions", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    ,
    {
        scaleType: 4,
        precision: 3,
        scale: 3,
        precisionType: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CompactFormatOptions;
